/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext } from 'react';
import CustomButton from '../../../../shared/forms/CustomButton';
import CustomInput from '../../../../shared/forms/CustomInput';
import AppContext from '../../../../../../context/shared/AppContext';
import Label from '../../../../shared/forms/Label';

const AddStaticIpCustomer = () => {
  const { loadingForm, onChange, formValue, onSubmit } = useContext(AppContext);
  const { customer_name, public_ip, private_ip } = formValue;
  const submitForm = () => {
    return customer_name.length > 0 && public_ip.length > 0 && private_ip.length > 0;
  };
  return (
    <div id="add-access-point" className="modal fade mt-5" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header shadow">
            <h4 className="modal-title update_asset">Static Ip</h4>
            <button type="button" className="btn btn-outline-info btn-circle btn-close" data-dismiss="modal">
              x
            </button>
          </div>
          <div className="modal-body detail mb-4 p-0">
            <form
              className="col-md-12 p-0"
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Customer Name" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="customer_name"
                    value={customer_name}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="eg fiber home"
                    type="text"
                    id="customerEmail"
                  />
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Public IP" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="public_ip"
                    value={public_ip}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="e.G (196.50.4.15)"
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Private IP" />

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="private_ip"
                    value={private_ip}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="eg (192.168.37.15)"
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>

              <div className="text-center mt-3">
                {loadingForm ? (
                  <CustomButton classname="btn btn-green px-3" name="Adding..." disabled={loadingForm} />
                ) : (
                  <CustomButton classname="btn btn-green px-3" name="Add" disabled={!submitForm()} />
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStaticIpCustomer;
